import { RootState } from '@reducers';

export const selectDocument = (state: RootState) => state.userDashboardRouteReducer.document;
